import { postShares } from '../api/cloudShare';
export default async ({ refresh, shareAuth, shareToken }, logger) => {
    if (refresh) {
        if (shareToken) {
            const authRefreshData = new URLSearchParams();
            authRefreshData.append('shareToken', shareToken);
            return postShares(authRefreshData, '/auth/refresh', {}, logger);
        }
        throw Error('Invalid share token usage');
    }
    else if (shareAuth.key === 'inviteKey' || shareAuth.key === 'shareUid') {
        const shareAuthData = new URLSearchParams();
        shareAuthData.append(shareAuth.key, shareAuth.value);
        return postShares(shareAuthData, '/auth', {}, logger);
    }
    throw Error('Invalid auth param usage. Either one of shareUid or inviteKey param should be specified.');
};
